<p class="alert">
  <mat-icon>radio_button_checked</mat-icon>
  Hola&nbsp;<strong>{{ name | titlecase }}</strong>, ya
  estas en vivo con un agente
</p>
